import { useSessionState } from './session-state-hook';
import { sessionKey } from '../util/session-storage';

// Store editable fields only, never the full server user record.
export const useProfileState = (scope, profile, fields) =>
  useSessionState(sessionKey(scope, 'profile'), profile, {
    serialize: (value) =>
      value &&
      Object.fromEntries(
        ['_id', ...fields]
          .filter((field) => ['string', 'number'].includes(typeof value[field]))
          .map((field) => [field, value[field]])
      ),
    restore: (saved, fallback) => {
      if (!fallback || !saved || saved._id !== fallback._id) return fallback;
      return {
        ...fallback,
        ...Object.fromEntries(
          fields
            .filter((field) => ['string', 'number'].includes(typeof saved[field]))
            .map((field) => [field, saved[field]])
        )
      };
    }
  });
